import {put,takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';

import {TYPES as USER_QUESTION_TYPE} from '../creators/user.question';

export function* createSuccess(action) {
    try {
        yield put({type: "USER_QUESTIONS_ADD", data : action.payload});
    } catch (error) {

    }
}

export function* deleteSuccess(action) {
    try {
        yield put({type: "USER_QUESTIONS_DELETE", data : action.payload});
    } catch (error) {

    }
}

export function* watchUserQuestion() {
    yield takeEvery(USER_QUESTION_TYPE.CREATE_SUCCESS, createSuccess);
    yield takeEvery(USER_QUESTION_TYPE.DELETE_SUCCESS, deleteSuccess);
}

export default watchUserQuestion;

